import {
  IncidentTactic,
  useIncidentTactics,
} from './hooks/incidentTacticHooks';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../SharedIcon/SharedIcon';
import EntityList from './EntityList';
import { useToggle } from 'react-use';
import { Card } from 'react-bootstrap';
import { useState } from 'react';
import classNames from 'classnames';
import TacticAddDrawer from './TacticAddDrawer';
import TacticEditDrawer from './TacticEditDrawer';
import { IapScope, INCIDENT, ORGANIZATION } from './ICSConstants';

import { MdEdit } from 'react-icons/md';
import { useTactics, Tactic } from './hooks/tacticHooks';

type TacticEntity = IncidentTactic | Tactic;

const CollapsibleTacticsList = ({ scope = INCIDENT }: { scope?: IapScope }) => {
  const [expanded, toggleExpanded] = useToggle(false);
  const [editOpen, toggleEditDrawer] = useToggle(false);
  const [addOpen, toggleAddDrawer] = useToggle(false);
  const [selectedEntity, setSelectedEntity] = useState<TacticEntity | null>(
    null
  );

  const { data: incidentTactics } = useIncidentTactics(scope);
  const isEnabled = scope === ORGANIZATION;
  const { data: organizationTactics } = useTactics(isEnabled);

  const isIncident = scope === INCIDENT;
  const entities = isIncident ? incidentTactics : organizationTactics;

  const selectElement = (element: TacticEntity) => {
    setSelectedEntity(element);
    toggleEditDrawer();
  };

  return (
    <>
      <EntityList
        entities={entities}
        expanded={expanded}
        toggleExpanded={toggleExpanded}
        header={
          <div className="d-flex align-items-center justify-content-between flex-grow-1">
            <span>{`${isIncident ? 'Incident' : 'Organization'} Tactics`}</span>
            <StylishNewButton
              className={classNames('button', {
                'button--primary': expanded,
                'button--secondary': !expanded,
              })}
              onClick={toggleAddDrawer}
            >
              <SharedIcon iconName="add" classes="me-2" />
              Add
            </StylishNewButton>
          </div>
        }
        renderEntity={(element) => (
          <Card
            key={element.id}
            className="bg-neutral-800 my-1 rounded-1 flex-row align-items-center justify-content-between"
            style={{
              padding: '0.625rem 1rem 0.625rem 1rem',
            }}
          >
            <span>{element.name}</span>
            <StylishNewButton
              className="button button--link"
              onClick={() => selectElement(element)}
            >
              <MdEdit />
            </StylishNewButton>
          </Card>
        )}
      ></EntityList>
      {addOpen ? (
        <TacticAddDrawer toggle={toggleAddDrawer} scope={scope} />
      ) : null}
      {editOpen && selectedEntity ? (
        <TacticEditDrawer
          toggle={toggleEditDrawer}
          selectedEntity={selectedEntity}
          scope={scope}
        />
      ) : null}
    </>
  );
};

export default CollapsibleTacticsList;
